import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import ParentSidebar from './ParentSidebar';

export default function ParentLayout() {
  return (
    <Box sx={{ display: 'flex', flex: 1 }}>
      <ParentSidebar />
      <Box component="main" sx={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </Box>
    </Box>
  );
}
